import { Platform } from 'react-native';

export const WEB_DESKTOP_BREAKPOINT = 961;

export const breakpoints = {
  base: 0, // mobile min-width breakpoint
  sm: 480, // ??

  ...(Platform.OS === 'web'
    ? {
        // eliminates md tablet breakpoint on web for all but 1 px because it doesn't look good and was very broken here without this
        // we can't fully eliminate it because setting md=lg px makes xl not work right.
        md: WEB_DESKTOP_BREAKPOINT,
        lg: 962, // sm desktop min-width breakpoint
        xl: 1280, // xl desktop min-width breakpoint
      }
    : {
        // This effectively forces tablets to use native phone layouts regardless of size
        // Why? We had lots of issues with tablets or other exotic devices and they are <0.5% of native usage.
        // This fixes the issues and cuts off any future bugs associated with them.
        md: 9999,
        lg: 9999,
        xl: 9999,
      }),
};
